import {
  ActionIcon,
  Button,
  Group,
  Highlight,
  Paper,
  Stack,
  Tooltip
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { generatePath, Link } from "react-router";
import { Userpilot } from "userpilot";
import { ROUTES } from "../../../../routes";
import { SiteSetupProcessStatus } from "../../../../types/api.types";
import { useShouldShowStaffView } from "../../../StaffViewToggle/useShouldShowStaffView";
import type { SiteSetupProcess } from "../../hooks/useSiteSetupProcesses";
import { DisplayStatus } from "./DisplayStatus";

interface SetupProcessItemProps {
  projectId: string;
  setupProcess: SiteSetupProcess;
  highlightTerm: string;
  onDelete: (site: SiteSetupProcess) => void;
}

function SetupProcessItem({
  projectId,
  setupProcess,
  highlightTerm,
  onDelete
}: SetupProcessItemProps) {
  const { shouldShowStaffView } = useShouldShowStaffView();

  const path = generatePath(ROUTES.project.siteSetupAssistant, {
    projectId: projectId,
    siteSetupProcessId: setupProcess.id
  });

  const continueEditingButtonLabel =
    setupProcess.status === SiteSetupProcessStatus.NotConfigured
      ? "Daten erfassen"
      : setupProcess.status === SiteSetupProcessStatus.InProgress
        ? "Fortschritt bearbeiten"
        : "";

  const userPilotId =
    setupProcess.status === SiteSetupProcessStatus.NotConfigured
      ? "Liko-Button-DatenErfassen"
      : "";

  const handleButtonClick = () => {
    if (userPilotId) {
      Userpilot.track(userPilotId);
    }
  };

  return (
    <Paper className="SetupProcessItem" p="md" shadow="none" withBorder>
      <Stack gap="lg">
        <Group gap="lg" justify="space-between">
          <Group>
            <Link to={path}>
              <Highlight fw={500} highlight={highlightTerm}>
                {setupProcess.name}
              </Highlight>
            </Link>
            <DisplayStatus status={setupProcess.status} />
          </Group>
          {shouldShowStaffView && (
            <Tooltip label="Liegenschaft löschen">
              <ActionIcon
                c="error"
                size="xs"
                variant="transparent"
                onClick={() => onDelete(setupProcess)}
              >
                <IconTrash />
              </ActionIcon>
            </Tooltip>
          )}
        </Group>
        {setupProcess.status !== SiteSetupProcessStatus.Completed && (
          <Group justify="flex-end">
            <Button
              color="primary"
              component={Link}
              id={userPilotId}
              td="none"
              to={path}
              variant="outline"
              onClick={handleButtonClick}
            >
              {continueEditingButtonLabel}
            </Button>
          </Group>
        )}
      </Stack>
    </Paper>
  );
}
export { SetupProcessItem, SetupProcessItemProps };
